import axios from "axios";

const axiosInstance = axios.create({
    baseURL: "https://assignment6-video.herokuapp.com",
});

export default axiosInstance;
